import {AbstractModel} from '../abstract-model';

export class TopPartnerStat extends AbstractModel {
  partnerId: number | null = null;
  partnerCompanyName: string = '';
  amount: number = 0;
}
